<template>
  <el-drawer
    v-model="isOpen"
    :before-close="close"
    :size="size"
    header-class="drawer-header"
    body-class="drawer-body"
    footer-class="drawer-footer"
  >
    <template #header>
      <slot name="header"></slot>
    </template>
    <slot></slot>
    <template #footer>
      <slot name="footer"></slot>
    </template>
  </el-drawer>
</template>

<script>
export default {
  popupController: null,
  props: {
    withHeader: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: "600px",
    },
  },
  data() {
    return {
      isOpen: true,
    };
  },
  beforeUnmount() {
    this.$options.popupController = null;
  },
  methods: {
    async open() {
      let resolve;
      let reject;
      const popupPromise = new Promise((ok, fail) => {
        resolve = ok;
        reject = fail;
      });
      this.$options.popupController = { resolve, reject };
      this.isOpen = true;
      return popupPromise;
    },
    close(done) {
      if (this.$options.popupController?.resolve) {
        this.$options.popupController.resolve({ action: "cancel" });
      }
      this.isOpen = false;
      done();
    },
  },
};
</script>

<style lang="scss">
.drawer-header {
  @apply bg-gray-50 border-b border-gray-200;
  padding: 16px !important;
}
.drawer-body {
  padding: 16px !important;
}
.drawer-footer {
  @apply bg-gray-50 border-t border-gray-200;
  padding: 16px !important;
}
</style>
